import { Pipe, PipeTransform } from '@angular/core';

import { IParsedCurrencyDataForFilter } from './pages/currencies-filter/currencies-filter.component';

/**
 * https://cloud-tfs.office.listatsoftware.com/tfs/Stealthtech/Hypersphere/_workitems/edit/2556/
 * Search using by 2 passes:
 * 1st pass - search matching of the filter string from the beginning of the token name or currency code (ETH, USDT, etc.).
 * 2nd pass - search matching in the middle of the token name or currency code (ETH, USDT, etc.).
 * Show result of the 1st pass in the top, lower the results of second pass without duplicating the entries of the 1st pass.
 */
@Pipe({ name: 'currencyFilter' })
export class CurrencyFilterPipe implements PipeTransform
{
    private static StartStrategy(_item: string, search: string)
    {
        return _item.startsWith(search);
    }

    private static IncludesStrategy(_item: string, search: string)
    {
        return _item.includes(search);
    }

    private SatisfyFilter(_item: IParsedCurrencyDataForFilter, search: string, _strategy: (_item: string, search: string) => boolean): boolean
    {
        var res = _strategy(_item.name.toLowerCase(), search);
        if (!res)
        {
            res = _strategy(_item.symbol.toLowerCase(), search);
        }
        return res;
    }

    private sortByState(items)
    {
        if (items.checked)
            return -1;
        return 1;
    }

    transform(items: IParsedCurrencyDataForFilter[], searchText: string): IParsedCurrencyDataForFilter[]
    {
        if (!items.length) return items;

        if (!searchText)
        {
            items.sort(this.sortByState);
            const [ checkedSorted, uncheckedSorted ] = [
                items.filter(item => item.checked).sort((a, b) => a.name.localeCompare(b.name)),
                items.filter(item => !item.checked).sort((a, b) => a.name.localeCompare(b.name)),
            ];

            items = [ ...checkedSorted, ...uncheckedSorted ];
            return items;
        }

        searchText = searchText.toLowerCase();

        //NOTE: Ordered.
        var strategies = [ CurrencyFilterPipe.StartStrategy, CurrencyFilterPipe.IncludesStrategy ];

        var filteredArray: IParsedCurrencyDataForFilter[] = [];

        for (let strategy of strategies)
        {
            for (let item of items)
            {
                if (!filteredArray.includes(item) && this.SatisfyFilter(item, searchText, strategy))
                {
                    filteredArray.push(item);
                }
            }
        }

        filteredArray.sort(this.sortByState);
        const [ checkedSorted, uncheckedSorted ] = [
            filteredArray.filter(item => item.checked).sort((a, b) => a.name.localeCompare(b.name)),
            filteredArray.filter(item => !item.checked).sort((a, b) => a.name.localeCompare(b.name)),
        ];

        filteredArray = [ ...checkedSorted, ...uncheckedSorted ];

        return filteredArray;
    }
}
